import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import Menu from "./Menu";

const LiveTV = () => {
  const cameras = useMemo(
    () => [
      {
        id: 1,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_01.mp4",
        alt: "Camera 1",
      },
      {
        id: 2,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_02.mp4",
        alt: "Camera 2",
      },
      {
        id: 3,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_03.mp4",
        alt: "Camera 3",
      },
      {
        id: 4,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_04.mp4",
        alt: "Camera 4",
      },
      {
        id: 5,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_05.mp4",
        alt: "Camera 5",
      },
      {
        id: 6,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_06.mp4",
        alt: "Camera 6",
      },
      {
        id: 7,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_07.mp4",
        alt: "Camera 7",
      },
      {
        id: 8,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_08.mp4",
        alt: "Camera 8",
      },
      {
        id: 9,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_09.mp4",
        alt: "Camera 9",
      },
      {
        id: 10,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_10.mp4",
        alt: "Camera 10",
      },
      {
        id: 11,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_11.mp4",
        alt: "Camera 11",
      },
      {
        id: 12,
        src: "https://sybf.fr/wp-content/themes/sybf/src/assets/videos/camera_12.mp4",
        alt: "Camera 12",
      },
    ],
    []
  );

  const [currentCameraIndex, setCurrentCameraIndex] = useState(0);
  const [clickDisabled, setClickDisabled] = useState(false);
  const cameraRefs = useRef([]);

  const handlePrevClick = useCallback(() => {
    if (!clickDisabled) {
      setClickDisabled(true);
      setTimeout(() => setClickDisabled(false), 300);
      setCurrentCameraIndex((prevIndex) =>
        prevIndex === 0 ? cameras.length - 1 : prevIndex - 1
      );
    }
  }, [cameras.length, clickDisabled]);

  const handleNextClick = useCallback(() => {
    if (!clickDisabled) {
      setClickDisabled(true);
      setTimeout(() => setClickDisabled(false), 300);
      setCurrentCameraIndex((prevIndex) =>
        prevIndex === cameras.length - 1 ? 0 : prevIndex + 1
      );
    }
  }, [cameras.length, clickDisabled]);

  useEffect(() => {
    const currentCameraRef = cameraRefs.current[currentCameraIndex];
    if (currentCameraRef) {
      currentCameraRef.classList.add("camera-image-animate");
      const handleAnimationEnd = () =>
        currentCameraRef.classList.remove("camera-image-animate");
      currentCameraRef.addEventListener("animationend", handleAnimationEnd);
      return () =>
        currentCameraRef.removeEventListener(
          "animationend",
          handleAnimationEnd
        );
    }
  }, [currentCameraIndex]);

  return (
    <div className="live-tv">
      <div className="video-container">
        <img
          src="https://sybf.fr/wp-content/themes/sybf/src/assets/img/Vector_camera.svg"
          alt="vector_camera"
          className="vector_camera"
        />
        {cameras.map((camera, index) => (
          <div
            key={camera.id}
            className="camera"
            style={{ display: index === currentCameraIndex ? "block" : "none" }}
          >
            <video
              ref={(el) => (cameraRefs.current[index] = el)}
              className="camera-image"
              src={camera.src}
              muted
              autoPlay
              loop
              playsInline
            />
          </div>
        ))}
      </div>
      <Menu
        handlePrevClick={handlePrevClick}
        handleNextClick={handleNextClick}
        clickDisabled={clickDisabled}
      />
    </div>
  );
};

export default LiveTV;
